import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Container, Table, Pagination, Modal } from 'react-bootstrap';
import {
  FaSortNumericDown,
  FaSortNumericUpAlt,
  FaSortAlphaDown,
  FaSortAlphaUpAlt,
  FaFileExcel,
  FaEdit,
  FaTrash
} from 'react-icons/fa';
import exportFromJSON from 'export-from-json';

import styles from './Usuarios.module.css';
import getAllUsers from '../../../api/getAllUsers';
import { decrypt, decryptArray } from '../../../helpers/cryptography';
import isoToDate from '../../../helpers/isoToDate';
import { formatDate } from '../../../helpers/formatDate';
import deletarUsuario from '../../../api/deletarUsuario';

const Usuarios = () => {
  const history = useHistory();

  const [sortNome, setSortNome] = useState(false);
  const [sortEmail, setSortEmail] = useState(false);
  const [sortTelefone, setSortTelefone] = useState(false);
  const [sortUnidade, setSortUnidade] = useState(false);
  const [sortAdmissao, setSortAdmissao] = useState(false);
  const [sortMatricula, setSortMatricula] = useState(false);
  const [sortPerfil, setSortPerfil] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const [filterBy, setFilterBy] = useState('name');
  const [orderBy, setOrderBy] = useState('desc');
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const toExcel = async () => {
    setExcelLoading(true);

    const fileName = 'solicitacoes';
    const exportType = 'xls';

    const getAll = await getAllUsers();

    const data = getAll.map(item => {
      const excelData = {
        nome: item.name ? decrypt(item.name) : '',
        matricula: item.registration ? decrypt(item.registration) : '',
        email: item.email ? decrypt(item.email) : '',
        telefone: item.phone ? decrypt(item.phone) : '',
        unidade: item.unit ? decrypt(item.unit) : '',
        data_admissao: item.admissionDate ? formatDate(item.admissionDate) : '',
        perfil: item.roles ? decryptArray(item.roles) : ''
      };

      return excelData;
    });

    exportFromJSON({ data, fileName, exportType });

    setExcelLoading(false);
  };

  useEffect(() => {
    setLoading(true);

    const getUsers = async () => {
      const response = await getAllUsers();
      
      const responseDecrypted = response.map(user => {
        return {
          ...user,
          name: user.name ? decrypt(user.name) : '',
          email: user.email ? decrypt(user.email) : '',
          phone: user.phone ? decrypt(user.phone) : '',
          unit: user.unit ? decrypt(user.unit) : '',
          admissionDate : user.admissionDate ? user.admissionDate : '',
          registration: user.registration ? decrypt(user.registration) : '',
          roles: user.roles ? decryptArray(user.roles) : '',
        };
      }).sort((a, b) => a.name > b.name ? 1 : -1);
      
      setUsuarios(responseDecrypted);
      setTotalPages(1);
      setLoading(false);
    };

    getUsers();
  }, [currentPage, filterBy, orderBy, refresh]);

  const usuariosNovo = () => {
    history.push('/admin/usuarios/novo');
  };

  const handleSortNome = () => {
    setSortNome(!sortNome);

    if (!sortNome) {
      setFilterBy('name');
      setOrderBy('asc');
    } else {
      setFilterBy('name');
      setOrderBy('desc');
    }
  };

  const handleSortEmail = () => {
    setSortEmail(!sortEmail);

    if (!sortEmail) {
      setFilterBy('email');
      setOrderBy('asc');
    } else {
      setFilterBy('email');
      setOrderBy('desc');
    }
  };

  const handleSortTelefone = () => {
    setSortTelefone(!sortTelefone);

    if (!sortTelefone) {
      setFilterBy('phone');
      setOrderBy('asc');
    } else {
      setFilterBy('phone');
      setOrderBy('desc');
    }
  };

  const handleSortUnidade = () => {
    setSortUnidade(!sortUnidade);

    if (!sortUnidade) {
      setFilterBy('unit');
      setOrderBy('asc');
    } else {
      setFilterBy('unit');
      setOrderBy('desc');
    }
  };

  const handleSortAdmissao = () => {
    setSortAdmissao(!sortAdmissao);

    if (!sortAdmissao) {
      setFilterBy('admissionDate');
      setOrderBy('asc');
    } else {
      setFilterBy('admissionDate');
      setOrderBy('desc');
    }
  };

  const handleSortMatricula = () => {
    setSortMatricula(!sortMatricula);

    if (!sortMatricula) {
      setFilterBy('registration');
      setOrderBy('asc');
    } else {
      setFilterBy('registration');
      setOrderBy('desc');
    }
  };

  const handleSortPerfil = () => {
    setSortPerfil(!sortPerfil);

    if (!sortPerfil) {
      setFilterBy('roles');
      setOrderBy('asc');
    } else {
      setFilterBy('roles');
      setOrderBy('desc');
    }
  };

  const handlePageChange = pageNumber => {
    if (pageNumber < 1) {
      pageNumber = 1;
    }

    if (pageNumber > totalPages) {
      pageNumber = totalPages;
    }

    setCurrentPage(pageNumber);
  };

  const editar = id => {
    history.push(`/admin/usuarios/${id}`);
  };

  const deletar = id => {
    setDeleteId(id);

    const usuario = usuarios.find(user => user._id === id);

    setDeleteName(usuario.name);
    setShowDeleteModal(true);
  };

  const handleDeleteModalClose = () => setShowDeleteModal(false);

  const handleDeletarUsuario = async () => {
    try {
      await deletarUsuario(deleteId);
    } catch (error) {
      console.log(error);
    }

    setShowDeleteModal(false);

    setRefresh(!refresh);
  };

  return (
    <Container>
      <div className={styles.button_container}>
        <Button variant='flat' className={styles.btn} onClick={usuariosNovo}>Criar Usuário</Button>

        {!excelLoading && (
          <Button onClick={toExcel} variant="success">
            <FaFileExcel className={styles.icon} />Excel
          </Button>
        )}

        {excelLoading && (
          <Button onClick={toExcel} variant="success" disabled>
            <FaFileExcel className={styles.icon} />Baixando...
          </Button>
        )}
      </div>

      {loading && <p>Carregando...</p>}

      {!loading && usuarios?.length > 0 && (
        <>
          <Table striped bordered hover responsive="sm" size="sm">
            <thead>
              <tr>
                <th>
                  Nome {
                    !sortNome ?
                      <FaSortAlphaDown onClick={handleSortNome} className={styles.sort} /> :
                      <FaSortAlphaUpAlt onClick={handleSortNome} className={styles.sort} />
                  }
                </th>
                <th>
                  Email {
                    !sortEmail ?
                      <FaSortAlphaDown onClick={handleSortEmail} className={styles.sort} /> :
                      <FaSortAlphaUpAlt onClick={handleSortEmail} className={styles.sort} />
                  }
                </th>
                <th /* style={{ width: '13%' }} */>
                  Telefone {
                    !sortTelefone ?
                      <FaSortNumericDown onClick={handleSortTelefone} className={styles.sort} /> :
                      <FaSortNumericUpAlt onClick={handleSortTelefone} className={styles.sort} />
                  }
                </th>
                <th>
                  Unidade {
                    !sortUnidade ?
                      <FaSortAlphaDown onClick={handleSortUnidade} className={styles.sort} /> :
                      <FaSortAlphaUpAlt onClick={handleSortUnidade} className={styles.sort} />
                  }
                </th>
                <th>
                  Admissão {
                    !sortAdmissao ?
                      <FaSortNumericDown onClick={handleSortAdmissao} className={styles.sort} /> :
                      <FaSortNumericUpAlt onClick={handleSortAdmissao} className={styles.sort} />
                  }
                </th>
                <th>
                  Matrícula {
                    !sortMatricula ?
                      <FaSortNumericDown onClick={handleSortMatricula} className={styles.sort} /> :
                      <FaSortNumericUpAlt onClick={handleSortMatricula} className={styles.sort} />
                  }
                </th>
                <th>
                  Perfil {
                    !sortPerfil ?
                      <FaSortAlphaDown onClick={handleSortPerfil} className={styles.sort} /> :
                      <FaSortAlphaUpAlt onClick={handleSortPerfil} className={styles.sort} />
                  }
                </th>
                <th>Editar</th>
                <th>Deletar</th>
              </tr>
            </thead>
            <tbody>
              {usuarios && usuarios.map(usuario => {
                return (
                  <tr key={usuario?._id}>
                    <td>{usuario?.name}</td>
                    <td>{usuario?.email}</td>
                    <td>{usuario?.phone}</td>
                    <td>{usuario?.unit}</td>
                    <td>{usuario?.admissionDate ? isoToDate(usuario.admissionDate) : ''}</td>
                    <td>{usuario?.registration}</td>
                    <td>{
                      usuario?.roles.join(', ')
                    }</td>
                    <td><FaEdit onClick={() => editar(usuario?._id)} className={styles.sort} /></td>
                    <td><FaTrash onClick={() => deletar(usuario?._id)} className={styles.sort} /></td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <div className="d-flex justify-content-center">
            <Pagination>
              <Pagination.First onClick={() => handlePageChange(1)} />
              <Pagination.Prev onClick={() => handlePageChange(Number(currentPage) - 1)} />
              {Array.from({ length: totalPages }).map((item, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === Number(currentPage)}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next onClick={() => handlePageChange(Number(currentPage) + 1)} />
              <Pagination.Last onClick={() => handlePageChange(totalPages)} />
            </Pagination>
          </div>

          <Modal show={showDeleteModal} onHide={handleDeleteModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Deletar usuário</Modal.Title>
            </Modal.Header>
            <Modal.Body>Tem certeza que deseja deletar o usuário:</Modal.Body>
            <Modal.Body><strong>{deleteName}</strong></Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleDeleteModalClose}>
                Não
              </Button>
              <Button variant="flat" className={styles.btn} onClick={handleDeletarUsuario}>
                Sim
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </Container>
  );
};

export default Usuarios;
